import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./scss/custom.scss";
import { Provider } from "react-redux";
import { store } from "./features/store";
import { CookiesProvider } from "react-cookie";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CookiesProvider defaultSetOptions={{ path: "/" }}>
        <App />
      </CookiesProvider>
    </Provider>
  </React.StrictMode>
);
